import { useTranslation } from "react-i18next";
// Constants - Functions
import { protocols } from "../../../../../../config/constants";
import { importImages } from "../../../../../../config/functions";
// Components
import RenderProtocol from "../renderProtocol";

const RenderProtocols = ({ protocolId, sessionsNumber }) => {
  const [t] = useTranslation("global");

  const basicProtocolsImg = importImages(
    require.context("../../../../../../assets/images/protocols/prescriptions/app/basics", false, /\.(png|jpe?g|svg)$/)
  );
  const arProtocolsImg = importImages(
    require.context("../../../../../../assets/images/protocols/prescriptions/app/ar", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.app.basic.CONSTELLATIONS.id]: {
      img: basicProtocolsImg["./constellations.png"],
      name: "protocols_constellationsApp",
      video: "protocols_constellationsAppVideo",
      description: "protocols_constellationsAppDescription",
    },
    [protocols.app.basic.QUALITY_CONTROL_BASIC.id]: {
      img: basicProtocolsImg["./quality_control.png"],
      name: "protocols_qualityControlBasic",
      video: "protocols_qualityControlBasicVideo",
      description: "protocols_qualityControlBasicDescription",
    },
    [protocols.app.ar.CIRCLE.id]: {
      img: arProtocolsImg["./circle_vertical_AR.png"],
      name: "protocols_circle",
      video: "protocols_circleVideo",
      description: "protocols_circleDescription",
    },

    [protocols.app.ar.CIRCLE_HORIZONTAL.id]: {
      img: arProtocolsImg["./circle_horizontal_AR.png"],
      name: "protocols_circleHorizontal",
      video: "protocols_circleHorizontalVideo",
      description: "protocols_circleHorizontalDescription",
    },
  };

  return (
    <RenderProtocol
      protocolId={protocolId}
      sessionsNumber={sessionsNumber}
      protocolImg={protocolsData[protocolId].img}
      protocolName={t(protocolsData[protocolId].name)}
      videoLink={t(protocolsData[protocolId].video)}
      protocolDescription={t(protocolsData[protocolId].description)}
    />
  );
};

export default RenderProtocols;
